export * from './StudentDetail';
